import { render, staticRenderFns } from "./test_entry.vue?vue&type=template&id=7140dc2f&scoped=true"
import script from "./test_entry.vue?vue&type=script&lang=js"
export * from "./test_entry.vue?vue&type=script&lang=js"
import style0 from "./test_entry.vue?vue&type=style&index=0&id=7140dc2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140dc2f",
  null
  
)

export default component.exports